import { render, staticRenderFns } from "./OwnOrders.vue?vue&type=template&id=5c36a377&scoped=true&"
import script from "./OwnOrders.vue?vue&type=script&lang=js&"
export * from "./OwnOrders.vue?vue&type=script&lang=js&"
import style0 from "./OwnOrders.vue?vue&type=style&index=0&id=5c36a377&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36a377",
  null
  
)

component.options.__file = "OwnOrders.vue"
export default component.exports